import {educationProps} from './education.props'

import * as Types from './types'
import {failureGenerate, successGenerate} from '../common'
import {classroomInitial, ICategory, staffInitial} from '../../constants'
import moment from 'moment'
const INIT_STATE: educationProps = {
  classrooms: [],
  curriculums: [],
  homeworks: [],
  lastCacheTime: null,
  stories: [],
  story: null,
  classroom: classroomInitial,
  staff: staffInitial,
  staffs: [],
  categories: [],
  gradeLevels: [],
  students: [],
  lastRequestDate: null,
}

const educationReducer = (state = INIT_STATE, {type, payload}: any) => {
  switch (type) {
    case successGenerate(Types.SAVE_STAFF):
      return {
        ...state,
        staff: payload.data,
      }
    case successGenerate(Types.SET_STORIES):
      return {
        ...state,
        stories: payload.data.filter((item:any)=>item.storyTypeId ==1 ),
      }
    case successGenerate(Types.SET_GRADE_LEVELS):
      return {
        ...state,
        gradeLevels: payload.data,
      }
    case successGenerate(Types.SET_CATEGORIES):
      let categoryData = payload.data
      let returnCategories = categoryData.map((item: ICategory) => {
        return {
          id: item.id,
          defaultTitle: item.defaultTitle.replace('Education - ', ''),
          storyIds: item.storyIds,
        }
      })
      return {
        ...state,
        categories: returnCategories,
      }
    case successGenerate(Types.SET_CURRICULUMS):
      return {
        ...state,
        curriculums: payload.data,
      }
    case successGenerate(Types.SET_CLASSROOM):
      return {
        ...state,
        classroom: payload.data,
        students: [],
        homeworks: [],
      }
    case successGenerate(Types.SET_CLASSROOMS):
      return {
        ...state,
        classrooms: payload.data,
      }
    case successGenerate(Types.SET_STUDENT_LIST):
      if (!state.classroom.id || payload.data.some((student: any) =>
        String(student.classroomId) !== String(state.classroom.id))) return state
      return {
      ...state,
        students: payload.data,
      }
    case failureGenerate(Types.SET_STUDENT_LIST):
      return {
        ...state,
        students: [],
      }
    case successGenerate(Types.SET_LAST_CACHE_TIME):
      return {
        ...state,
        lastRequestDate: moment().utc().toDate(),
      }
    default:
      return state
  }
}

export {educationReducer}
